import { AfterViewInit, Directive, Host, Inject, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Page } from '@app/shared/models/page.interface';
import { Subject, Subscription } from 'rxjs';
import { DataTableNewComponent } from '../data-table-new.component';
import { DataTableState } from '../state/state.model';
import { StateService } from '../state/state.service';

export interface DataTablePageState {
  index: number;
  size: number;
}

@Directive({ selector: '[vfsDatatablePagination]', exportAs: 'vfsDatatablePagination' })
export class DatatablePaginationDirective implements OnInit, AfterViewInit, OnDestroy {
  stateId: string;
  stateChangeSubject$: Subject<DataTableState>;

  paginatorSubscription: Subscription;
  dataSubscription: Subscription;

  constructor(
    @Host() private parent: DataTableNewComponent<any>,
    @Inject('StateService') private stateService: StateService
  ) {}

  ngOnInit() {
    this.stateId = this.parent.stateId;
    this.stateChangeSubject$ = this.parent.stateChangeSubject$;
    this.parent.withPaginator = true;
  }

  ngAfterViewInit() {
    const state: DataTableState = this.stateService.get(this.stateId);

    this.parent.paginator.pageIndex = state.page.index;
    this.parent.paginator.pageSize = state.page.size;

    this.paginatorSubscription = this.parent.paginator.page.subscribe((event: PageEvent) => {
      const currentState: DataTableState = this.stateService.get(this.stateId);
      currentState.page.index = event.pageIndex;
      currentState.page.size = event.pageSize;

      this.stateService.update(currentState);

      this.stateChangeSubject$.next(currentState);
    });

    this.dataSubscription = this.parent.dataSource.getPageData().subscribe((page: Page<any>) => {
      if (page) {
        this.parent.paginator.pageIndex = page.number;
        this.parent.paginator.length = page.totalElements;
      }
    });
  }

  ngOnDestroy() {
    if (this.paginatorSubscription) {
      this.paginatorSubscription.unsubscribe();
    }

    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
}
